export enum AssetType {
    Cloud = 1,
    OnPrem = 2
}
